(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class VrAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.slides = this.querySelectorAll('[data-vr-ann-slide]');
        if (this.slides.length <= 1) return;
        this.current = 0;
        this.autoplay = this.getAttribute('data-autoplay') === 'true';
        this.interval = (parseFloat(this.getAttribute('data-interval')) || 5) * 1000;

        const prev = this.querySelector('[data-vr-ann-prev]');
        const next = this.querySelector('[data-vr-ann-next]');
        if (prev) prev.addEventListener('click', () => this.go(-1));
        if (next) next.addEventListener('click', () => this.go(1));

        if (this.autoplay) this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => { if (this.autoplay) this.start(); });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => { if (this.autoplay) this.start(); });
      }

      disconnectedCallback() {
        this.stop();
      }

      go(dir) {
        const total = this.slides.length;
        const idx = (this.current + dir + total) % total;
        this.activate(idx);
      }

      activate(idx) {
        this.slides[this.current].classList.remove('is-active');
        this.slides[idx].classList.add('is-active');
        this.current = idx;
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => this.go(1), this.interval);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    if (!customElements.get('vr-announcement-bar')) {
      customElements.define('vr-announcement-bar', VrAnnouncementBar);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
